import { PagedSearchAction } from '../../../../core/features/store/actions/search.actions';
import { EntriesState } from '../../../../core/features/store/base-feature-state';
import { SoldTo, SoldToSearchResult } from '../../../../core/model';
import { SoldToActions } from '../actions';
import { AvailableSoldToActionTypes } from '../actions/sold-to-available.action';

export const initialState: EntriesState<SoldTo> = {};

export function reducer(searchType: string) {
  return (state = initialState, action: PagedSearchAction): EntriesState<SoldTo> => {
    if (searchType !== action.searchType) {
      return state;
    }
    switch (action.type) {
      case AvailableSoldToActionTypes.LoadAvailableSoldTosSuccess:
      case AvailableSoldToActionTypes.LoadAvailableSoldTosOnUserDetailsSuccess: {
        const soldTosSuccess = <SoldToActions.LoadAvailableSoldTosSuccess>action;
        const payload: SoldToSearchResult = soldTosSuccess.payload;

        const results = payload.results;

        return results.reduce(
          (entities: { [uid: string]: SoldTo }, entry: SoldTo) => {
            return {
              ...entities,
              [entry.uid]: entry,
            };
          },
          {
            ...state,
          }
        );
      }
      default:
        return state;
    }
  };
}
